import {theme} from "../../../../../utils";

export type ResourceItemType = {
    title: string;
    fileUrl: string;
};

export type ResourceListType = {
    listItems: ResourceItemType[];
    buttonText:string,
    buttonIcon:any
};

export const styles = {
    listContainer: {
        mt:"32px",
        flex:1,
        flexWrap:"wrap",
        px:"31px"
    },
    itemListWrapper: {
        borderBottom: "1px solid #4B69F1",
        pb: "28px",
        pt: "43px",
        flex:1,
        textAlign:"left"
    },
    listRow: {
        display:"flex",
    },
    listTitle: {
        ...theme.typography.montseratH1,
        fontSize: "19.94px",
        color: "#1E1E22",
        flex: 1
    },
    downloadLabel: {
        ...theme.typography.montseratBodyRegular,
        fontSize: "16.31px",
        color: theme.palette.primary.main,
        textTransform: "capitalize"
    },
    mobileWrapper: {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start"
    },
    download: {
        button: {
            mt: 0,
            pt:0,
            pl:0,
            display: "flex"
        },
        downloadIcon: {
            paddingRight: "8px",
            width: "15px",
        },
        downloadText: {
            ...theme.typography.body1Regular,
            fontSize: "15px",
            color: theme.palette.primary.main,
            textTransform: "capitalize",
            lineHeight: "150%",
            letterSpacing: "-1.5%",
        }
    }
}


